export default {
  methods: {
    async render_bar(data) {
      console.log(data);
      let xAxisData = data && data.length ? data.map(v => v.name) : []
      let seriesData = data && data.length ? data.map(v => v.visitNum) : []
      let proportion = data && data.length ? data.map(v => v.proportion) : []
      let option = {
        color: ['#3CA0FE'],
        title: {
          text: "用户年龄分布",
          x: "left",
          y: "top",
          left: 10,
          textStyle: {
            fontWeight: "normal",
            fontSize: 16,
          },
          z: 1,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        grid: {
          left: '4%',
          right: '10%',
          bottom: '3%',
          containLabel: true,
          top: '10%'
        },
        xAxis: {
          show: false,
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          data: xAxisData
        },
        series: [
          {
            type: 'bar',
            data: seriesData,
            barWidth: 16  ,
            itemStyle: {
              normal: {
                color: "#24c69a",
                label: {
                  show: true, //开启显示
                  position: 'right', //顶部显示
                  formatter: (params) => {
                    // console.log(params)
                    return '' + params.value + '' + '' + '{a|' + proportion[params.dataIndex] + '%}';
                  },
                  rich: {
                    a: {
                      color: '#777777',
                      fontSize: 11,
                      padding: [0, 20]
                    },
                  },
                },
                borderRadius: [0, 20, 20, 0],

              },

            },
          },
        ]
      };
      let $instance = this.$echarts.init(this.$refs['barChats']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
      });
    }
  }
}